import request from './common/request'
import qs from 'qs'

import { SYSTEM_MERCHANT_ME_URL } from './urls'

/**
 * 获取当前管理员权限列表
 * @returns
 */
async function getPermissions () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ME_URL}/permissions`,
      method: 'GET'
    }
  )
}

/**
 * 获取当前管理员菜单列表
 * @returns
 */
async function getMenus () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ME_URL}/menus`,
      method: 'GET'
    }
  )
}

/**
 * 获取当前管理员角色
 * @returns
 */
async function getRole () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ME_URL}/role`,
      method: 'GET'
    }
  )
}

/**
 * 获取所有的权限组列表
 * @returns
 */
async function getAllPermissionGroups () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ME_URL}/permissiongroups`,
      method: 'GET'
    }
  )
}

async function getMerchantInfo () {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ME_URL}/merchantInfo`,
      method: 'GET'
    }
  )
}

async function saveMerchantInfo (data) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ME_URL}/merchantInfo`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

export default {
  getPermissions,
  getMenus,
  getRole,
  getMerchantInfo,
  getAllPermissionGroups,
  saveMerchantInfo
}



// WEBPACK FOOTER //
// ./src/api/merchant-me.js